export const BASE_URL = "https://stage.handsfreeapi.com";
// export const BASE_URL = "https://handsfreeapi.com";

export const KEY = "jO5l6qHl6XeXdwpREwskjU8NluQKxQ";

export const SECRET = "bI6MTeojhr7UQK3vH5P1r3CHeHC6XD";
